import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@ipreo/muni-shared';
import { GamedaySharedModule } from '../shared/shared.module';
import { DonutChartComponent } from './components/donut-chart/donut-chart.component';
import { MoneyTypeComponent } from './components/money-type/money-type.component';
import { OrderSummaryChartComponent } from './components/order-summary-chart/order-summary-chart.component';
import { OrderSummaryCardComponent } from './components/order-summary-card/order-summary-card.component';
import { OrderSummaryBarChartComponent } from './components/order-summary-chart/order-summary-bar-chart.component';
import { SmallLoadingComponent } from './components/money-type/small-loading/small-loading.component';
import { PortfolioComponent } from './components/portfolio/portfolio.component';
import { ProfileLinkComponent } from './components/profile-link/profile-link.component';
import { NoDataComponent } from './components/portfolio/no-data/no-data.component';
import { ProfileComponent } from './components/profile/profile.component';
import { AccountService } from './services/account.service';
import { NoRoundPercentsPipe } from './pipes/no-round-percents.pipe';

@NgModule({
  imports: [CommonModule, GamedaySharedModule, SharedModule],
  declarations: [
    DonutChartComponent,
    MoneyTypeComponent,
    OrderSummaryCardComponent,
    OrderSummaryBarChartComponent,
    OrderSummaryChartComponent,
    PortfolioComponent,
    ProfileLinkComponent,
    ProfileComponent,
    SmallLoadingComponent,
    NoDataComponent,
    NoRoundPercentsPipe
  ],
  providers: [AccountService],
  exports: [ProfileComponent, ProfileLinkComponent, NoRoundPercentsPipe]
})
export class ProfileModule {}
